const DEFAULT_OPTION = { defaultValue: 10 };

/**
 * @param {number|string} value
 * @param {{ defaultValue: number }} [option]
 * */
export default function getPerPageQueryParam(value, { defaultValue } = DEFAULT_OPTION) {
  const parsed = parseInt(value, 10);
  if (Number.isNaN(parsed)) {
    console.error(`Per page is not a number. type: ${typeof value}. value: ${value}.`);
    return { perPage: defaultValue };
  }

  return { perPage: value };
}
